import React from "react";
import { useNavigate } from "react-router-dom";
import { buildSrcSet } from "../utils/imageUrl";

const CategoryCard = (props) => {
  const navigate = useNavigate();

  // console.log("props category card", props);
  const navigateToSubCat = () => {
    navigate("subcategory", {
      state: {
        categoryID: props?.categoryID,
      },
    });
  };

  const navigateToProducts = () => {
    navigate("products", {
      state: {
        categoryID: props?.categoryID,
        // subCategoryID: props?.subCategoryID,
      },
    });
  };

  return (
    <div
      className="col-span-12 md:col-span-6 lg:col-span-4 bg-white rounded-lg shadow-md  mb-6"
      onClick={() => navigateToProducts()}
    >
      <img
        src={props?.image}
        srcSet={buildSrcSet(props?.image) || undefined}
        sizes="(min-width: 1024px) 400px, (min-width: 768px) 46vw, 92vw"
        alt={props?.title}
        loading="lazy"
        decoding="async"
        className="w-full h-48 object-cover overflow-hidden transform hover:scale-105 transition duration-300"
      />
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-800">{props?.title}</h3>
        {props?.description && (
          <p className="text-gray-600 mt-2 text-sm">{props?.description}</p>
        )}
      </div>
    </div>
  );
};

export default CategoryCard;
